import { render } from "./executiveChangeRequest.vue?vue&type=template&id=6e6d2b7f&scoped=true"
import script from "./executiveChangeRequest.vue?vue&type=script&lang=js"
export * from "./executiveChangeRequest.vue?vue&type=script&lang=js"

import "./executiveChangeRequest.vue?vue&type=style&index=0&id=6e6d2b7f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6d2b7f"]])

export default __exports__